import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import '../shared.css';

const RoleDetail = () => {
  const { id } = useParams();
  const history = useHistory();
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage,   setErrorMessage]   = useState('');
  const [selectedOption, setSelectedOption] = useState({ value: '1', label: 'Master' });

  const [formData, setFormData] = useState({
    Name: '',
    Claims: [],
    UpdatedBy: userId,
  });

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, token, logout]);

  useEffect(() => {
    fetchData('RoleApi', `/RoleDetails/${id}`, token)
      .then(response => {
        if (response.responseCode === '1111' && response.response_data) {
          const { RoleVM } = response.response_data;
          setFormData(prev => ({
            ...prev,
            ...RoleVM,
            Claims: response.response_data.Claims
              ? response.response_data.Claims.map(c => ({ ...c })) : [],
          }));
        }
      })
      .catch(err => {
        console.error('Error fetching Role Details:', err);
        setErrorMessage('Error fetching Role Details. Please try again.');
      });
  }, [id]);

  const getClaimRange = () => {
    const startIndex = (parseInt(selectedOption.value, 10) - 1) * 5;
    return { startIndex, endIndex: startIndex + 4 };
  };

  const handleClaimChange = (index) => {
    const updatedClaims = [...formData.Claims];
    updatedClaims[index].IsSelected = !updatedClaims[index].IsSelected;
    setFormData(prev => ({ ...prev, Claims: updatedClaims }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');

    const payload = { ...formData, UpdatedBy: userId };

    updateData('RoleApi', `${id}`, payload, token)
      .then(() => {
        setSuccessMessage('Role updated successfully.');
        setTimeout(() => history.push(`/roleDetail/${id}`), 1000);
      })
      .catch(err => {
        console.error('Error updating record:', err);
        setErrorMessage('Failed to update role. Please try again.');
      });
  };

  return (
    <div className="pg-container">
      {/* ── Header ── */}
      <div className="pg-header">
        <h5 className="pg-title">Role — Details</h5>
        <div className="pg-action-row">
          <button className="pg-btn pg-btn-success" onClick={handleSubmit}>
            <DoneIcon /> Update
          </button>
          <Link to="/RoleIndex" className="pg-btn pg-btn-danger">
            <CloseIcon /> Cancel
          </Link>
        </div>
      </div>

      {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
      {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

      {/* ── Role Name ── */}
      <div className="pg-card">
        <div className="pg-form-grid" style={{ gridTemplateColumns: '1fr 2fr' }}>
          <div className="pg-field">
            <label className="pg-label">Role Name</label>
            <input className="pg-input" value={formData.Name} readOnly placeholder="Role Name" />
          </div>
        </div>
      </div>

      {/* ── Claims ── */}
      <div className="pg-card">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <span style={{ fontWeight: 700, fontSize: 13, color: '#1c2a3a' }}>Claims</span>
        </div>

        {/* Category selector */}
        <div style={{ maxWidth: 260, marginBottom: 14 }}>
          <div className="pg-field">
            <label className="pg-label">Claim Category</label>
            <div style={{ marginTop: 6 }}>
              <Select
                options={[
                  { value: '1', label: 'Master' },
                  { value: '2', label: 'Transaction' },
                  { value: '3', label: 'Reports' },
                  { value: '4', label: 'Administration' },
                ]}
                value={selectedOption}
                onChange={setSelectedOption}
              />
            </div>
          </div>
        </div>

        {/* Claims list */}
        {formData.Claims && formData.Claims.length > 0
          ? formData.Claims.map((claim, index) => {
              const { startIndex, endIndex } = getClaimRange();
              if (index < startIndex || index > endIndex) return null;
              return (
                <div key={index} style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '6px 8px', borderBottom: '1px solid rgba(200,212,224,0.3)',
                  borderRadius: 4, transition: 'background 0.12s',
                }}>
                  <label htmlFor={`claim-${index}`} style={{ fontSize: 12.5, color: '#374151', cursor: 'pointer', flex: 1 }}>
                    {claim.ClaimValue}
                  </label>
                  <input
                    type="checkbox"
                    id={`claim-${index}`}
                    checked={claim.IsSelected}
                    onChange={() => handleClaimChange(index)}
                    style={{ width: 15, height: 15, accentColor: '#c9a96e', cursor: 'pointer' }}
                  />
                </div>
              );
            })
          : <p style={{ fontSize: 12, color: '#94a3b8' }}>No claims available.</p>
        }
      </div>

      <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
    </div>
  );
};

export default RoleDetail;
